import { render, staticRenderFns } from "./PromoOffers.vue?vue&type=template&id=336af247&"
import script from "./PromoOffers.vue?vue&type=script&lang=js&"
export * from "./PromoOffers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports